import { useState, useCallback, } from 'react';
import { connect } from 'react-redux';
import { format } from 'date-fns';

import { PROMO_CODE_SET_EXPIRATION, SET_EXPIRATION_PROMO_CODE_DIALOGUE_OPEN, DateStringMMDDYYYY, ShareScheduleCode, } from '../actions/types';
import { siteboardAction, } from '../actions/defaultActions';
import PopupWindow from './PopupWindow';
import PushButton from './PushButton';
import CalendarPicker from './CalendarPicker';

const DialogueSetPromoCodeExpiration = ({ _promoCodes, _setExpirationPromoCodeDialoguePromoCodeId, siteboardAction, }) => {
  const selectedPromoCode = _promoCodes[_setExpirationPromoCodeDialoguePromoCodeId];

  const [inputDate, setInputDate] = useState(format(selectedPromoCode ? new Date(selectedPromoCode.expiresAtTimestamp) : new Date(), 'MM/dd/yyyy'));

  const closeDialogue = useCallback(() => {
    siteboardAction(SET_EXPIRATION_PROMO_CODE_DIALOGUE_OPEN, { isOpen: false, promoCodeId: '', });
  }, [siteboardAction]);

  const onUpdatePromoExpiration = () => {
    const onSuccess = () => {
      closeDialogue();
    };
    siteboardAction(PROMO_CODE_SET_EXPIRATION, { code: selectedPromoCode.code, expiresAtTimestamp: DateStringMMDDYYYY.toDateObject(inputDate).getTime() }, onSuccess);
  };

  if(selectedPromoCode === undefined) return (<></>);

  return (
    <PopupWindow title='Set Expiration' closeDialogue={closeDialogue} bgStyle='bg-[#333]'>
      <div className='max-w-[400px] bg-[#333] text-white'>
        <div className='w-[400px]' />
        <div className='py-2'>
          Set expiration date for promo code <b>{ShareScheduleCode.truncate(selectedPromoCode.code)}</b>. 
        </div>
        <div className='mt-1'>
          <div className='w-full' >
            <div className='h-[300px]'>
              <CalendarPicker selectedDate={inputDate} onDateChange={(dateString) => { setInputDate(dateString); }} onSubmit={onUpdatePromoExpiration} />
            </div>
          </div>
        </div>
        <div className='flex mt-4'>
          <PushButton 
            textColor='white'
            bgColor='#471cff'
            hoverBgColor='#603aff'
            onClick={onUpdatePromoExpiration}
          >
            Set Expiration
          </PushButton>
        </div>
      </div>
    </PopupWindow>
  );
};

// define redux state that will be passed in as props
const mapStateToProps = state => { return {
  _promoCodes: state.serverSynced.promoCodes,
  _setExpirationPromoCodeDialoguePromoCodeId: state.localEphemeral.setExpirationPromoCodeDialoguePromoCodeId,
}};
export default connect(mapStateToProps, { siteboardAction })(DialogueSetPromoCodeExpiration);
